module.exports = __webpack_public_path__ + "static/formulas2-1391880ef6361c774ba8a74fb3a16324.jpg";